export enum TipoDestinoCampanha {
  Suitability = 'Suitability',
}
